import { DescriptionsWithCTA } from './DescriptionsWithCTA';
import { MediaWithCaption } from './MediaWithCaption';
import { Numbers } from './Numbers';
import { Headline } from './Headline';
export { DescriptionsWithCTA, MediaWithCaption, Numbers, Headline };
